import React, { useState } from 'react';
import { Modal as ModalComponent } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { Container, Label, Center, ConfirmButton, RowContainer, CheckboxContainer, CheckboxLabel, Checkbox, } from './modalStyles';
import { CANCEL, COMPLETE_TICKET } from 'src/Utils/constants';
import { Warning } from 'src/assets/Images';
var CompleteTicketModal = function (_a) {
    var isOpen = _a.isOpen, setIsOpen = _a.setIsOpen, onConfirm = _a.onConfirm, showNotifyCheckbox = _a.showNotifyCheckbox;
    var _b = useState(false), notifyClient = _b[0], setNotifyClient = _b[1];
    var handleComplete = function () {
        setNotifyClient(false);
        setIsOpen(false);
    };
    var handleConfirm = function () {
        onConfirm(notifyClient);
        setNotifyClient(false);
        setIsOpen(false);
    };
    return (React.createElement(ModalComponent, { open: isOpen },
        React.createElement(Center, null,
            React.createElement(Container, null,
                React.createElement(RowContainer, { className: "right close" },
                    React.createElement(Close, { onClick: handleComplete })),
                React.createElement(RowContainer, null,
                    React.createElement("img", { src: Warning, alt: "Warning" })),
                React.createElement(RowContainer, { className: "column" },
                    React.createElement(Label, { className: "title" }, "\u00BFEst\u00E1s seguro de que deseas completar este ticket?"),
                    React.createElement(Label, { className: "bold" }, "Esta acci\u00F3n no se puede deshacer.")),
                showNotifyCheckbox && (React.createElement(CheckboxContainer, null,
                    React.createElement(Checkbox, { type: "checkbox", id: "notifyClient", checked: notifyClient, onChange: function (e) { return setNotifyClient(e.target.checked); } }),
                    React.createElement(CheckboxLabel, { htmlFor: "notifyClient" }, "Notificar al cliente sobre la finalizaci\u00F3n del ticket"))),
                React.createElement(RowContainer, null,
                    React.createElement(ConfirmButton, { onClick: handleConfirm }, COMPLETE_TICKET),
                    React.createElement(Label, { className: "cancel", onClick: handleComplete }, CANCEL))))));
};
export default CompleteTicketModal;
